<template>
    <v-dialog v-model="mostrar" persistent max-width="70vw" >
		<v-card height="32vh" max-height="600px">
			<v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
			<v-divider></v-divider>
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <h2 class="text-center">Você está excluindo a publicacao "{{publicacao.nome}}"</h2>
                        <h3 class="text-center">Confirma a exclusão?</h3>
                    </v-col>
                </v-row>
            </v-container>
            <v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="confirmar()">Confirmar</v-btn>
				<v-btn text color="primary" @click.stop="mostrar = false">Cancelar</v-btn>
			</v-card-actions>
		</v-card>
    </v-dialog>    
</template>

<script>
import Br from '@/config/barramento.js'
import metodos from '@/mixins/metodos'

// import { mapState } from 'vuex'
import { baseApiUrl, showError, showSuccess } from "@/config/global"
import axios from 'axios'


export default {
    name: 'Categoria',
    mixins: [metodos],
    components:{
        
    },
    data(){
        return{
            cor: 'primary',
            mostrar: false,
            publicacao: {},
        }
    },

    methods:{
        confirmar(){
            if(this.publicacao.status == 'rascunho'){
                
                const url = `${baseApiUrl}/estudos/delete.php`
                
                axios.post(url, {id: this.publicacao.id})
                    .then(res => {

                        if(res.data.codigo == '01'){
                            Br.setPublicacaoExcluida(this.publicacao)
                            showSuccess('Publicação excluida com sucesso')
                        }else{
                            showError(res.data.mensagem)
                        }
                    })
                    
                    this.close()
            }else{
                showError('Não é possivel excluir uma publicação ativa!')
            }
        },

        close(){
            this.mostrar = false
        },
    },

    created(){
    
        Br.onExcluirPublicacao(publicacao => {
            
            this.publicacao = publicacao
            this.mostrar = true
        })
    }
}
    </script>